import { createActions, createReducer } from 'reduxsauce'

import RecursosVinculadosService from '../servicos/RecursosVinculadosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaRecursosVinculadosInicio: [],
    buscaRecursosVinculadosSucesso: ['recursosVinculados'],
    buscaRecursosVinculadosErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaRecursosVinculados = () => {
    return dispatch => {
        dispatch(Creators.buscaRecursosVinculadosInicio())
        let serv = new RecursosVinculadosService()
        return serv
            .getRecursosVinculadosPorExercicio()
            .then(response => dispatch(Creators.buscaRecursosVinculadosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaRecursosVinculadosErro(error)))
    }
}

const buscaRecursosVinculadosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaRecursosVinculadosErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaRecursosVinculadosSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.recursosVinculados, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_RECURSOS_VINCULADOS_INICIO]: buscaRecursosVinculadosInicio,
    [Types.BUSCA_RECURSOS_VINCULADOS_ERRO]: buscaRecursosVinculadosErro,
    [Types.BUSCA_RECURSOS_VINCULADOS_SUCESSO]: buscaRecursosVinculadosSucesso,
})
